import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout' 

export default async function CertUpload(formData, alias, password) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }
   
    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/certificate?&certificatePassword=' + password + "&certificateAlias=" + alias , {
            method: 'POST',
            headers: { 
                'Authorization' : unHashedJwt,
                'Content-Type': 'multipart/form-data'
            },
            data: formData
        }).then(
            res => (
                res
            )
        ).catch(error => {
            return error.response.data
            }
        )
    )
}